export default class Datos3Drender {
  constructor() {
    return {
      gruposCampos: [
        {
          grupo: "VIDRIO",
          visual: "SI",
          includes: ["TIPO_VIDRIO", "DECORADO", "MATERIAL"],
        },
        {
          grupo: "PERFIL",
          visual: "SI",
          includes: ["COLOR_PERFIL"],
        },
        {
          grupo: "TIRADOR",
          visual: "SI",
          includes: ["POMO"],
        },
        {
          grupo: "MEDIDAS",
          visual: "SI",
          includes: [],
        },
        {
          grupo: "VIDRIO",
          visual: "NO",
          includes: ["ACABADO", "ESPESOR", "ANTICAL"],
        },
        {
          grupo: "PERFIL",
          visual: "NO",
          includes: ["N_RAL", "PIEZAS"],
        },
        {
          grupo: "TIRADOR",
          visual: "NO",
          includes: [],
        },
        {
          grupo: "MEDIDAS",
          visual: "NO",
          includes: [
            "ALTURA",
            "MEDIDAS",
            "LATERAL",
            "POSICION",
            "HOJA",
            "PERFILERIA",
            "FRONTAL",
            "GUIA",
            "DELHI_ECO",
          ],
        },
      ],
      gruposTrad: [
        {
          grupo: "VIDRIO",
          literales: [
            {
              codIdioma: "es",
              texto: "Vidrio",
            },
          ],
        },
        {
          grupo: "PERFIL",
          literales: [
            {
              codIdioma: "es",
              texto: "Perfil",
            },
          ],
        },
        {
          grupo: "TIRADOR",
          literales: [
            {
              codIdioma: "es",
              texto: "Tirador",
            },
          ],
        },
        {
          grupo: "MEDIDAS",
          literales: [
            {
              codIdioma: "es",
              texto: "Medidas",
            },
          ],
        },
        {
          grupo: "REVESTIMIENTO",
          literales: [
            {
              codIdioma: "es",
              texto: "Revestimiento",
            },
          ],
        },
        {
          grupo: "OTROS",
          literales: [
            {
              codIdioma: "es",
              texto: "Otros",
            },
          ],
        },
      ],
      revestimiento: [
        {
          campo: "SUELO",
          ces: "Suelo",
          acabado: "PARKET",
          aes: "Paquet",
        },
        {
          acabado: "AZULEJO",
          aes: "Azulejo",
        },
        {
          acabado: "HORMIGON",
          aes: "Hormigón",
        },
        {
          campo: "PARED",
          ces: "Pared",
          acabado: "CLARO",
          aes: "Claro",
        },
        {
          acabado: "MEDIO",
          aes: "Medio",
        },
        {
          acabado: "OSCURO",
          aes: "Oscuro",
        },
      ],
    };
  }
}
